import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import UnitConvert from 'UnitConverter';
import Util from 'utility';
import api from 'api';
import { openModal, closeModal, setFoodAmount } from '../../../../actions/index';
import LectureTaskPanelFoodModifications from '../../../Plan/LectureTask/LectureTaskPanelFoodModifications';
import { __ } from 'locale';


function PanelMain() {
    const data = useSelector(state => state);
    const dispatch = useDispatch();
    const { globals } = data;
    const [focusedAmountInputId, setFocusedAmountInputId] = useState(0);
    const [focusedAmountInputValue, setFocusedAmountInputValue] = useState('');

    const openFoodModificationsPanel = (e, m, f) => {
        e.preventDefault();
        dispatch(closeModal());
        dispatch(openModal({
            title: 'Úpravy potraviny ' + f.title,
            class: 'dialog-flexible',
            content: <LectureTaskPanelFoodModifications food={f} />
        }));
    };

    const showAlergenInfo = (alerg) => {
        dispatch(openModal({ title: 'Alergen', content: <div className="p-[0.5em]"><p>{alerg}</p></div> }));
    };

    const handleFoodAmountInputFocus = (e, food) => {
        e.target.select();
        setFocusedAmountInputId(food.id);
        setFocusedAmountInputValue(parseFloat(food.weight) + '');
    };

    const handleFoodAmountInputBlur = (e, mealHash, food) => {
        let weight = e.target.value.replace(',', '.') * 1;
        const item = globals.itemData[food.food_id];
        if (isNaN(weight) || weight < item.weight_min || weight > item.weight_max) {
            alert('Neplatné množství potraviny - zadejte prosím množství od ' + item.weight_min + ' do ' + item.weight_max + ' ' + item.weight_unit);
            weight = item.weight;
        }
        setFocusedAmountInputId(0);
        setFocusedAmountInputValue('');
        dispatch(setFoodAmount({ mealHash, foodId: food.id, weight }));
        Util.doLoadDayEvaluation();
    };

    const loadFoodDescription = (foodId) => {
        api('food/description/' + foodId).then(result => {
            result = result.data;
            if (result.error) return;
            dispatch(closeModal());
            dispatch(openModal({
                title: result.title,
                class: 'dialog dialog-flexible',
                content: (
                    <div className="p-[0.5em]">
                        <div dangerouslySetInnerHTML={{ __html: result.description }} />
                    </div>
                )
            }));
        });
    };

    const mealHash = data.activeMealHash;
    const foodGroups = data.foodGroups[mealHash];

    const sortedFoodGroupKeys = Object.keys(foodGroups)
        .map(g => ({ id: g, item_order: foodGroups[g].item_order }))
        .sort((a, b) => a.item_order - b.item_order);

    const m = '1|0';
    const watchAlergens = (typeof data.appModeData?.watchAlergens === 'object' ? data.appModeData.watchAlergens : []).map(a => +a);

    const elementFoodGroups = sortedFoodGroupKeys.map(key => {
        const fg = foodGroups[key.id];
        const foods = (data.foods[m] || [])
            .filter(f => f.group_id === fg.id)
            .map(f => {
                const foodItemData = globals.itemData[f.food_id];
                const foodItem = {
                    id: f.food_id,
                    selectedWeight: f.weight,
                    weight: foodItemData.weight,
                    norm_unit_amount: foodItemData.norm_unit_amount * 1.0,
                    norm_unit_unit: foodItemData.norm_unit_unit,
                    norm_unit2_amount: foodItemData.norm_unit2_amount * 1.0,
                    norm_unit2_unit: foodItemData.norm_unit2_unit
                };
                const uc = UnitConvert;
                const rawInfo = uc.convert(foodItem);
                const normalizedAmountInfo = (rawInfo && rawInfo !== '' && rawInfo !== ' null')
                    ? <span>({rawInfo})</span>
                    : null;

                const inputValue = focusedAmountInputId === f.id ? focusedAmountInputValue : parseFloat(f.weight + '');

                let alergenList = [];
                if (typeof globals.foodAlergens[f.food_id] === 'object') {
                    globals.foodAlergens[f.food_id].sort().forEach(id => {
                        const alergenName = globals.itemAlergens[id];
                        const shortName = alergenName.split('-')[0].trim();
                        const style = watchAlergens.includes(id * 1)
                            ? { cursor: 'pointer', borderBottom: '1px dotted #f00', color: '#f00' }
                            : { cursor: 'pointer', borderBottom: '1px dotted #bbb' };
                        alergenList.push(<span key={id} onClick={() => showAlergenInfo(alergenName)} style={style}>{shortName}</span>);
                        alergenList.push(<span key={id + '_c'}>, </span>);
                    });
                    if (alergenList.length > 0) alergenList.pop();
                }

                let undesirableInfo = null;
                const showUndesirableWarning = !Util.isNutriKucharMode(data.appMode);
                if (showUndesirableWarning && data.appModeData?.undesirableFoods?.includes(f.food_id)) {
                    undesirableInfo = alergenList.length > 0
                        ? <p className="pb-[3px] text-[0.9em] text-[#f00] m-0"><span>Nevhodná potravina: <span style={{fontWeight:'normal',color:'#000'}}>{alergenList}</span></span></p>
                        : <p className="pb-[3px] text-[0.9em] text-[#f00] m-0"><span>Nevhodná potravina</span></p>;
                } else if (alergenList.length > 0) {
                    undesirableInfo = <p className="pb-[3px] text-[0.9em] m-0" style={{color:'#000'}}><span>{__('Alergeny')}: <span style={{fontWeight:'normal',color:'#000'}}>{alergenList}</span></span></p>;
                }

                const mods = typeof data.modifications[f.id] !== 'undefined'
                    ? data.modifications[f.id].map(key => globals.preparation_types[key]).join(', ')
                    : 'Bez úprav';

                return (
                    <div className="group flex items-center py-[0.9em] px-[1.5em] border-t border-b border-transparent hover:border-t-[#bdc7d5] hover:border-b-[#bdc7d5] last:mb-[0.5em]" key={f.id}>
                        <div className="basis-[50px] shrink-0 h-[50px] mr-[2em] bg-center bg-no-repeat bg-contain" style={{backgroundImage: `url(${f.image})`}}></div>
                        <div className="flex flex-1 flex-col">
                            <h4 className="font-bold text-[1.05em] mb-[0.15em] mt-0 flex items-center">{f.title}</h4>
                            <div className="flex items-center text-[0.9em]">
                                <div className="mr-[1em]">
                                    <input
                                        className="w-[4em] text-right px-[3px] py-[3px] border border-[#bdc7d5] rounded-sm mr-[5px]"
                                        type="text" name="weight"
                                        value={inputValue}
                                        onChange={e => setFocusedAmountInputValue(e.target.value)}
                                        onFocus={e => handleFoodAmountInputFocus(e, f)}
                                        onBlur={e => handleFoodAmountInputBlur(e, m, f)}
                                    />
                                    <span>{globals.itemData[f.food_id].weight_unit}</span>
                                </div>
                                {normalizedAmountInfo}
                            </div>
                            <div className="py-[4px] text-[0.9em]">
                                <a onClick={e => openFoodModificationsPanel(e, m, f)}><span className="relative inline-block before:content-[''] before:absolute before:left-0 before:bottom-0 before:w-full before:border-b before:border-dotted before:border-[#888]">{mods}</span></a>
                            </div>
                            {undesirableInfo}
                        </div>
                        <div className="flex items-center justify-end">
                            <div className="hidden group-hover:inline-block relative ml-[0.5em]">
                                <a className="text-[1em] py-[0.5em] px-[0.3em] text-[#888] hover:text-black" onClick={() => loadFoodDescription(f.food_id)}><i className="fa fa-question"></i></a>
                            </div>
                        </div>
                    </div>
                );
            });

        return (
            <div key={key.id} style={{margin:'0',width:'100%',background:'#fff'}}>
                <div className="mb-[1px] relative">
                    <div className="flex flex-col">{foods}</div>
                </div>
            </div>
        );
    });

    return (
        <div>
            <div>
                {elementFoodGroups}
            </div>
        </div>
    );
}

export default PanelMain;
